/** @jsxImportSource @emotion/react */
import React from 'react'

interface ShareIconProps {
  width?: number
  height?: number
  fill?: string
}

/**
 * ShareIcon component displays a share icon
 */
const ShareIcon: React.FC<ShareIconProps> = ({
  width = 16,
  height = 16,
  fill = '#F2B400',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M9.33333 5.66667V3L14 7.66667L9.33333 12.3333V9.6C6 9.6 3.66667 10.6667 2 13C2.66667 9.66667 4.66667 6.33333 9.33333 5.66667Z'
        fill={fill}
      />
    </svg>
  )
}

export default ShareIcon
